import fromWhomValues from "@/mock/from-whom-values";
import { adtypeFilterItems } from "./constants/filters";
import { numberFormatter } from "@/src/helpers/number-formatter";

export const getFromWhomValuesByTradeTypeAndCategory = (tradeType, category) => {
  const fromAll = fromWhomValues.FROM_WHOM.values.find((item) => item?.id === "all");
  const fromCorporate = fromWhomValues.FROM_WHOM.values.find((item) => item?.slug === "emlakcidan");
  const fromPersonal = fromWhomValues.FROM_WHOM.values.find((item) => item?.slug === "sahibinden");
  const fromContractor = fromWhomValues.FROM_WHOM.values.find((item) => item?.slug === "muteahhitten");
  const fromBank = fromWhomValues.FROM_WHOM.values.find((item) => item?.slug === "bankadan");

  const mapping = {
    FOR_SALE: {
      HOUSING: [...fromWhomValues.FROM_WHOM.values],
      WORKPLACE: [...fromWhomValues.FROM_WHOM.values],
      LAND: [fromAll, fromCorporate, fromPersonal, fromContractor, fromBank],
      TOURIST_FACILITY: [fromAll, fromCorporate, fromPersonal, fromContractor, fromBank],
    },
    FOR_RENT: {
      HOUSING: [fromAll, fromCorporate, fromPersonal, fromContractor],
      WORKPLACE: [fromAll, fromCorporate, fromPersonal, fromContractor],
      LAND: [fromAll, fromCorporate, fromPersonal],
      TOURIST_FACILITY: [fromAll, fromCorporate, fromPersonal],
    },
    FOR_EXCHANGE: {
      LAND: [fromAll, fromCorporate, fromPersonal, fromContractor],
    },
    FOR_DAILY_RENT: {
      HOUSING: [fromAll],
    },
    FOR_TRANSFER: {
      WORKPLACE: [fromAll, fromCorporate, fromPersonal, fromContractor],
    },
  };

  if (!tradeType || !category) {
    return [...fromWhomValues.FROM_WHOM.values];
  }

  return mapping[tradeType.key][category.key] || [...fromWhomValues.FROM_WHOM.values];
};

const getMinMaxText = (minValue, maxValue) => {
  const formatterMinValue = numberFormatter(minValue);
  const formatterMaxValue = numberFormatter(maxValue);
  if (!formatterMinValue && !formatterMaxValue) return "";
  if (!formatterMinValue && formatterMaxValue) return `0 - ${formatterMaxValue}`;
  if (formatterMinValue && !formatterMaxValue) return `${formatterMinValue} ve üzeri `;
  return `${formatterMinValue} - ${formatterMaxValue} `;
};

const addFilterParam = (convertParams, key, name, value) => {
  convertParams.push({ key, name, value: Array.isArray(value) ? value : [value] });
};

export const selectedFilterElements = (criteria) => {
  const convertParams = [];

  if (criteria?.location?.city && Object.keys(criteria?.location?.city)?.length > 0) {
    addFilterParam(convertParams, "city", "İl", criteria.location.city);
  }

  if (criteria?.location?.districts?.length > 0) {
    addFilterParam(convertParams, "districts", "İlçe", criteria.location.districts);
  }

  if (criteria?.location?.towns?.length > 0) {
    addFilterParam(convertParams, "towns", "Mahalle", criteria.location.towns);
  }

  if (criteria?.freetext?.value) {
    addFilterParam(convertParams, "free_text", "Arama Kelimesi", criteria.freetext);
  }

  if (criteria?.company?.value?.length > 0) {
    addFilterParam(
      convertParams,
      "company",
      "Firma",
      criteria.company?.value.map((company) => {
        return {
          ...company,
          id: Number(company?.id),
        };
      })
    );
  }

  const adTypeFilterValue = [];
  let typeFilter;

  criteria?.params?.forEach((item) => {
    if (Array.isArray(item.value)) {
      convertParams.push(item);
    } else {
      if (["price", "gross_square", "square", "square_meter_price"].includes(item.key)) {
        const isIncludeCurrencyType = item?.queryParams?.some((param) =>
          Object.prototype.hasOwnProperty.call(param, "para_birimi")
        );
        if (item.key === "price" && isIncludeCurrencyType) {
          addFilterParam(convertParams, "para_birimi", "Para Birimi", { name: item.value.currency.toUpperCase() });
        }
        addFilterParam(convertParams, item.key, item.name, {
          ...item.value,
          name: getMinMaxText(item.value.min, item.value.max),
        });
      } else if (adtypeFilterItems.includes(item.key)) {
        adTypeFilterValue.push({ ...item });
        typeFilter = { key: "ad_type", name: "İlan Tipi", value: adTypeFilterValue };
      } else {
        addFilterParam(convertParams, item.key, item.name, item.value);
      }
    }
  });

  if (typeFilter) {
    convertParams.push(typeFilter);
  }

  return convertParams;
};
